import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex justify-between items-center col-span-12" }
const _hoisted_3 = { class: "my-4 col-span-12" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "flex flex-col col-span-12" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "my-4 col-span-12 mt-9" }
const _hoisted_8 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitInfo()), ["prevent"])),
      class: "grid grid-cols-12 gap-x-5 text-black",
      autocomplete: "off"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.info")), 1),
        _createVNode(_component_Button, {
          id: "btn-save",
          label: _ctx.$t('labels.generic', { pt: 'Salvar', en: 'Save' }),
          type: "submit",
          class: "btn-primary p-button-sm",
          loading: _ctx.loading
        }, null, 8, ["label", "loading"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nome do capítulo", en: "Chapter name" })), 1),
        _createVNode(_component_InputText, {
          id: "chapter-name-input",
          type: "text",
          name: "name",
          modelValue: _ctx.infoData.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.infoData.name) = $event)),
          class: _normalizeClass(_ctx.v$.infoData.name.$error ? 'p-invalid' : ''),
          maxlength: 50
        }, null, 8, ["modelValue", "class"]),
        _createVNode(_component_Errors, {
          errors: _ctx.v$.infoData.name.$errors,
          actualLength: _ctx.infoData.name?.length,
          maxLength: 50
        }, null, 8, ["errors", "actualLength"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Data de início (Opcional)",
              en: "Start date (Optional)",
            })), 1),
        _createVNode(_component_Calendar, {
          inputId: "chapter-startdate-input",
          modelValue: _ctx.infoData.startDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.infoData.startDate) = $event)),
          dateFormat: "dd/mm/yy",
          manualInput: false,
          minDate: _ctx.today,
          showIcon: ""
        }, null, 8, ["modelValue", "minDate"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("objectives.inputs.description")), 1),
        _createVNode(_component_Textarea, {
          id: "chapter-description-input",
          autoResize: true,
          rows: "10",
          cols: "30",
          modelValue: _ctx.infoData.description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.infoData.description) = $event)),
          maxlength: 999
        }, null, 8, ["modelValue"])
      ])
    ], 32)
  ]))
}